(function () {
  var ficha = document.querySelector('[data-tb-ficha]');
  if (!ficha) return;

  var formulario = ficha.querySelector('[data-tb-formulario]');
  var opciones = formulario ? formulario.querySelectorAll('input[name="id"]') : [];

  function varianteElegida() {
    var marcada = formulario && formulario.querySelector('input[name="id"]:checked');
    return marcada || opciones[0];
  }

  function elegir(input) {
    opciones.forEach(function (o) { o.closest('.tb-oferta').classList.toggle('tb-elegida', o === input); });
    document.querySelectorAll('[data-tb-precio]').forEach(function (p) { p.textContent = input.getAttribute('data-precio'); });
    var url = new URL(window.location.href);
    url.searchParams.set('variant', input.value);
    window.history.replaceState({}, '', url.toString());
  }

  opciones.forEach(function (o) { o.addEventListener('change', function () { elegir(o); }); });

  function comprar(boton) {
    var elegida = varianteElegida();
    if (!elegida || !window.tbCarrito) {
      if (formulario) formulario.submit();
      return;
    }
    document.querySelectorAll('[data-tb-comprar]').forEach(function (b) { b.disabled = true; });
    window.tbCarrito.anadir(Number(elegida.value), 1).finally(function () {
      document.querySelectorAll('[data-tb-comprar]').forEach(function (b) { b.disabled = false; });
    });
  }

  if (formulario) {
    formulario.addEventListener('submit', function (e) {
      e.preventDefault();
      comprar();
    });
  }
  document.querySelectorAll('[data-tb-comprar]').forEach(function (b) {
    if (b.type !== 'submit') b.addEventListener('click', function (e) { e.preventDefault(); comprar(); });
  });

  var galeria = ficha.querySelector('[data-tb-galeria]');
  if (galeria) {
    var diapositivas = galeria.querySelectorAll('[data-tb-diapositiva]');
    var miniaturas = galeria.querySelectorAll('[data-tb-miniatura]');
    var puntos = galeria.querySelectorAll('.tb-galeria__puntos i');
    var actual = 0;

    var mostrar = function (n) {
      if (!diapositivas.length) return;
      actual = (n + diapositivas.length) % diapositivas.length;
      diapositivas.forEach(function (d, i) {
        var activa = i === actual;
        d.hidden = !activa;
        d.classList.toggle('tb-activa', activa);
        if (!activa) d.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      miniaturas.forEach(function (m, i) {
        m.classList.toggle('tb-activa', i === actual);
        if (i === actual) m.setAttribute('aria-current', 'true'); else m.removeAttribute('aria-current');
      });
      puntos.forEach(function (p, i) { p.classList.toggle('tb-activo', i === actual); });
    };

    miniaturas.forEach(function (m) {
      m.addEventListener('click', function () { mostrar(Number(m.getAttribute('data-tb-miniatura'))); });
    });

    var principal = galeria.querySelector('.tb-galeria__principal');
    var inicioX = null;
    principal.addEventListener('touchstart', function (e) { inicioX = e.touches[0].clientX; }, { passive: true });
    principal.addEventListener('touchend', function (e) {
      if (inicioX === null) return;
      var dx = e.changedTouches[0].clientX - inicioX;
      if (Math.abs(dx) > 40) mostrar(actual + (dx < 0 ? 1 : -1));
      inicioX = null;
    });

    var visor = ficha.querySelector('[data-tb-visor]');
    var visorImagen = ficha.querySelector('[data-tb-visor-imagen]');
    var botonAmpliar = galeria.querySelector('[data-tb-ampliar]');
    var cerrarVisor = function () {
      visor.hidden = true;
      document.body.classList.remove('tb-bloqueado');
      botonAmpliar.focus();
    };
    botonAmpliar.addEventListener('click', function () {
      var img = diapositivas[actual] && diapositivas[actual].querySelector('img');
      if (!img) return;
      visorImagen.src = img.currentSrc || img.src;
      visorImagen.alt = img.alt;
      visor.hidden = false;
      document.body.classList.add('tb-bloqueado');
      visor.querySelector('[data-tb-cerrar-visor]').focus();
    });
    visor.addEventListener('click', function (e) {
      if (e.target === visor || e.target.closest('[data-tb-cerrar-visor]')) cerrarVisor();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !visor.hidden) cerrarVisor();
    });
  }

  var entrega = ficha.querySelector('[data-tb-entrega]');
  if (entrega) {
    var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    var sumarHabiles = function (n) {
      var f = new Date();
      var k = 0;
      while (k < n) {
        f.setDate(f.getDate() + 1);
        var dia = f.getDay();
        if (dia !== 0 && dia !== 6) k++;
      }
      return f.getDate() + ' ' + meses[f.getMonth()];
    };
    var dias = {
      envio: Number(entrega.getAttribute('data-envio')),
      minimo: Number(entrega.getAttribute('data-minimo')),
      maximo: Number(entrega.getAttribute('data-maximo'))
    };
    entrega.querySelectorAll('[data-tb-fecha]').forEach(function (el) {
      el.textContent = sumarHabiles(dias[el.getAttribute('data-tb-fecha')]);
    });
  }

  var barra = ficha.querySelector('[data-tb-barra-fija]');
  var botonPrincipal = ficha.querySelector('.tb-ficha__comprar');
  if (barra && botonPrincipal && 'IntersectionObserver' in window) {
    var visible = false;
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        visible = !en.isIntersecting && en.boundingClientRect.top < 0;
        barra.classList.toggle('tb-visible', visible);
        barra.setAttribute('aria-hidden', visible ? 'false' : 'true');
        barra.querySelectorAll('button').forEach(function (b) { b.tabIndex = visible ? 0 : -1; });
      });
    });
    observador.observe(botonPrincipal);
  }

  var acordeon = ficha.querySelector('[data-tb-acordeon-ficha]');
  var destino = document.querySelector('[data-tb-destino-acordeon]');
  if (acordeon && destino) {
    var origen = acordeon.parentNode;
    var siguiente = acordeon.nextSibling;
    var consulta = window.matchMedia('(max-width: 989px)');
    var colocar = function () {
      if (consulta.matches) {
        destino.appendChild(acordeon);
        destino.hidden = false;
      } else {
        origen.insertBefore(acordeon, siguiente);
        destino.hidden = true;
      }
    };
    colocar();
    if (consulta.addEventListener) consulta.addEventListener('change', colocar);
  }
})();
